TS.ns('WL');

WL.EditBase = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config); 
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config); 

        var warningList = me.getDomainProperty('dgDocumentWarning_Property');
        if (warningList !== null) {
            warningList.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        if (dataItem.MessageType === "Warning") {
                            row.addClass("warning_yellow_row");
                        }

                        if (dataItem.MessageType === "Error") {
                            row.addClass("error_red_row");
                        }
                    }
                }
            } 
        }
    }

});

